import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=3146e36c&scoped=true&lang=html"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146e36c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SystemModal: require('/app/components/system/modal.vue').default,MassReparsePeriod: require('/app/components/mass-reparse-period.vue').default})
